import React from 'react';
import { ClientUrlFactory } from '../../ui-toolkit/rest/ClientUrlFactory';
import { Tabs, Text } from '@zillow/constellation';
import { Link } from 'react-router-dom';

export interface IIncomingTransactionsNavigationProps {
  transactionType?: 'checks' | 'wires' | 'achs';
}

export const IncomingTransactionsNavigation: React.FC<IIncomingTransactionsNavigationProps> = ({ transactionType }) => (
  <Tabs>
    <Tabs.List aria-label="Incoming Transactions Navigation">
      <Tabs.Tab
        id="tab-wires"
        as={Link}
        to={ClientUrlFactory().urlFor.incomingWires()}
        aria-selected={transactionType === 'wires'}
        data-test-id="navigate-to-wires"
      >
        <Text>Wires</Text>
      </Tabs.Tab>
      <Tabs.Tab
        id="tab-checks"
        as={Link}
        to={ClientUrlFactory().urlFor.incomingChecks()}
        aria-selected={transactionType === 'checks'}
        data-test-id="navigate-to-checks"
      >
        <Text>Checks</Text>
      </Tabs.Tab>
      <Tabs.Tab
        id="tab-achs"
        as={Link}
        to={ClientUrlFactory().urlFor.incomingAchs()}
        aria-selected={transactionType === 'achs'}
        data-test-id="navigate-to-achs"
      >
        <Text>ACHs</Text>
      </Tabs.Tab>
    </Tabs.List>
  </Tabs>
);
